import { OnInit, Component, ViewChild } from '@angular/core';
import { SwalComponent } from '@sweetalert2/ngx-sweetalert2';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { AppConfig } from 'app/app.config';
import { IMyDateModel, IAngularMyDpOptions } from 'angular-mydatepicker';
import { NgxSpinnerService } from 'ngx-spinner';
import { Observable } from 'rxjs';
import { ISelect } from 'app/shared/models/select.model';
import { ConfigurationService } from 'app/shared/services/configuration.service';
import { ValidatorService } from 'app/shared/services/validator.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { ModalEmployeesComponet } from 'app/views/modales/employees/modal-employees.component';
import { IDtoEmployee } from 'app/shared/models/employee/dto-employee.model';
import { WorkLeaveService } from '../workLeave.service';
import { IDtoWorkLeave } from 'app/shared/models/request/work-leave/dto-work-leave.model';
import { MatRadioChange } from '@angular/material';
import { IDtoPeriodType } from 'app/shared/models/employee/dto-period-type.model';
import { RelocationService } from '../relocation.service';
import { IDtoRelocation } from 'app/shared/models/request/relocation/dto-relocation.model';
import { IDtoCatalog } from 'app/shared/models/dto-catalog.model';
import { IDtoModuleLog } from 'app/shared/models/security/dto-module-log.model';
import { IdentityService } from '../../security/identity.service';
import { AdministrationService } from '../../quote/administration.service';

@Component({
    selector: 'app-relocation',
    styleUrls: ['relocation.style.scss'],
    templateUrl: 'relocation.template.html'
})
export class RelocationComponent implements OnInit {
    /**Validadores */
    private validator = ValidatorService;
    private fsaFlags = [false];
    private errorMessages: any;
    /**Notificaciones */
    @ViewChild('addSwal', { static: false }) private addSwal: SwalComponent;
    /**Formularios */
    private formRelocation: FormGroup;
    private locale: string = 'es';
    /**Catalogos */
    private catalogRelocationReasons: Observable<IDtoCatalog[]>;
    private catalogRequisitions: Observable<ISelect[]>;
    /**Modales */
    private modalRef: BsModalRef;
    private configModal = {
        backdrop: true,
        ignoreBackdropClick: true,
        keyboard: false,
    };
    private employee: IDtoEmployee;
    private employeePeriod: IDtoPeriodType;
    private hasEmployee = false;
    private currentDate: Date;
    private isOther: boolean;
    private codeNomCustomer: string;
    private pickerOptions: IAngularMyDpOptions;
    private isOpenPeriod: boolean;
    constructor(private formBuilder: FormBuilder
        , private configGeneral: AppConfig
        , private spinner: NgxSpinnerService
        , private relocationService: RelocationService
        , private configurationService: ConfigurationService
        , private modalService: BsModalService
        , private workLeaveService: WorkLeaveService
        , private identityService: IdentityService
        , private administrationService: AdministrationService) {

    }
    ngOnInit(): void {
        if (this.configurationService.isReady) {
            this.spinner.show();
            this.getCatalogs();
        } else {
            this.configurationService.settingsLoaded$.subscribe(x => {
                this.spinner.show();
                this.getCatalogs();
            });
        }
        this.initializeFormWorkLeave();
        this.getOpenCalendar();
    }
    private getCatalogs(): void {
        this.catalogRelocationReasons = this.relocationService.getCatalogRelocationReasons();
        this.spinner.hide();
    }

    private initializeFormWorkLeave() {
        this.formRelocation = this.formBuilder.group({
            relocationDate: [null, Validators.required],
            reasonId: [null, Validators.required],
            generateVacancy: [null, Validators.required],
            requisitionId: [null, Validators.required],
            observations: [null, [Validators.maxLength(500)]],
            employee: [null, Validators.required],
        });
    }
    private submitForm(): void {
        if (this.formRelocation.valid) {
            this.addSwal.title = 'Se registrará la reubicación para el empleado seleccionado.';
            this.addSwal.show();
        } else {
            this.configGeneral.newToast('Validación', 'Capture toda la información requerida para poder continuar', 'error');
            this.configGeneral.touchedControls(this.formRelocation);
        }
    }
    private openModalEmployees() {
        this.modalRef = this.modalService.show(ModalEmployeesComponet
            , Object.assign({ class: 'modal-lg' }, this.configModal));
        this.modalRef.content.onClose.subscribe((result) => {
            if (result) {
                this.formRelocation.reset();
                this.employee = result;
                this.formRelocation.get('employee').setValue(this.employee.employeeName);
                this.hasEmployee = true;
                this.codeNomCustomer = this.employee.employeeMarkName.split('-')[0];
                this.catalogRequisitions = this.relocationService.getCatalogRequisitions(this.employee.employeeCompanyId, this.codeNomCustomer);
            } else {
                this.hasEmployee = false;
            }
        });
    }
    private getDate(event: IMyDateModel) {
        return event.singleDate.jsDate;
    }
    private save(): void {
        this.spinner.show();
        let data = Object.assign({}, this.formRelocation.value as IDtoRelocation);
        data.employeeId = this.employee.id;
        data.employeeNum = this.employee.employeeNum;
        data.employeeName = this.employee.employeeNames;
        data.employeeLastName = this.employee.employeeLastName;
        data.employeeSecondLastName = this.employee.employeeSecondLastName;
        data.codeNomCustomer = this.codeNomCustomer;
        data.relocationDate = this.configGeneral.getLocalISOTime(this.getDate(this.formRelocation.value.relocationDate));
        data.creationDate = this.configGeneral.getLocalISOTime(this.currentDate);
        data.previousRequisitionId = this.employee.requisitionId;
        data.uKey = this.employee.uKey;
        data.hiringDate = this.employee.hiringDate;
        this.relocationService.addRelocation(data)
            .subscribe(
                (x) => {
                    if (this.configGeneral.notificationSuccessError(x)) {
                        let r = x.data as IDtoRelocation;
                        this.addModuleLog(r.id);
                        this.formRelocation.reset();
                        this.hasEmployee = false;
                    }
                    this.spinner.hide();
                },
                (errMessage) => {
                    this.spinner.hide();
                    this.configGeneral.newToast('Error', errMessage.error.exception, 'error');
                });
    }
    private restrictDate(current: Date) {
        //const current = new Date();
        current.setDate(current.getDate());
        var lastDay = new Date(current.getFullYear(), current.getMonth(), 0);
        this.pickerOptions = {
            dateFormat: 'dd.mm.yyyy',
            dateRange: false,
            disableSince: { year: current.getFullYear(), month: current.getMonth() + 1, day: 6 },
            disableDateRanges: [{
                begin: { year: 1000, month: 1, day: 1 },
                end: { year: current.getUTCFullYear(), month: current.getUTCMonth(), day: lastDay.getDate() }
            }]
        }
    }
    private addModuleLog(id: number): void {
        let dto = {} as IDtoModuleLog;
        dto.table = 'Relocations';
        dto.module = 'relocation';
        dto.action = 'new';
        dto.registryAffectedId = id;
        this.identityService.addModuleLog(dto).subscribe(
            (x) => { });
    }
    private getOpenCalendar(): void {
        this.workLeaveService.getCurrentDate().subscribe(x => {
            this.currentDate = new Date(x);
            this.administrationService.getOpenCalendar('open_relocation_calendar').subscribe(res => {
                let open = res;
                if (!open) {
                    this.isOpenPeriod = this.currentDate.getDate() < 6;
                    this.restrictDate(this.currentDate);
                } else {
                    this.isOpenPeriod = true;
                }
            });
        });
    }
}
